module.exports = __webpack_public_path__ + "static/cyric_book_lowder_pol-0b4dfa11232cf57e18580a592188954d.webp";